import { useEffect, useRef } from 'react';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import sendBeacon from '@/core/lib/send-beacon';

const TAB_COUNT_KEY = 'linkie_tab_count';

const useBounceTracker = () => {
  const { state } = usePlayground();
  const startTimeRef = useRef<number>(Date.now());

  useEffect(() => {
    const currentCount = parseInt(localStorage.getItem(TAB_COUNT_KEY) || '0', 10);
    localStorage.setItem(TAB_COUNT_KEY, (currentCount + 1).toString());

    const handleUnload = () => {
      const count = parseInt(localStorage.getItem(TAB_COUNT_KEY) || '1', 10) - 1;
      localStorage.setItem(TAB_COUNT_KEY, count.toString());

      if (count <= 0) {
        const timeSpent = (Date.now() - startTimeRef.current) / 1000;
        const isBounce = timeSpent < 10;

        const payload = {
          link_in_bio_id: state.payload._id!,
          is_unique_visitor: false,
          bounce: isBounce ? 1 : 0,
        };

        sendBeacon('analytics/track-visitor', payload);
      }
    };

    window.addEventListener('unload', handleUnload);

    return () => {
      const count = parseInt(localStorage.getItem(TAB_COUNT_KEY) || '1', 10) - 1;
      localStorage.setItem(TAB_COUNT_KEY, count.toString());

      window.removeEventListener('unload', handleUnload);
    };
  }, [state.payload._id]);

  return null;
};

export default useBounceTracker;
